define('controllers/conversations/Podio.Controllers.Conversations.Notifications',['require','underscore','translate','lib/backbone/Backbone.PodioController','lib/Podio.UI.PushNotifications','lib/view_helpers/base','lib/Podio.Config','lib/Podio.Event','jst!notifications/push/notification','jst!notifications/push/_audio_video_footer'],function(require) {

  var _ = require('underscore');
  var t = require('translate');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var Notifications = require('lib/Podio.UI.PushNotifications');
  var viewHelpers = require('lib/view_helpers/base');
  var podioConfig = require('lib/Podio.Config');
  var podioEvent = require('lib/Podio.Event');

  var jstNotification = require('jst!notifications/push/notification');
  var jstAudioVideoFooter = require('jst!notifications/push/_audio_video_footer');

  return PodioController.extend({
    NOTIFICATION_SOUND: viewHelpers.sound_url('conversation_notification'),
    CALL_SOUND: viewHelpers.sound_url('podiocall'),

    notSuppressableTypes: ['live_start'],

    pushEvents: {
      'user': {
        'conversation_event ignoreOwn': 'onPushConversationEvent',
        'conversation_read': 'onPushConversationRead'
      }
    },

    initialize: function(options) {
      _.bindAll(this, 'onPushConversationEvent', 'onPushConversationRead');

      if (options) {
        this.suppressBubbles = options.suppressBubbles;
      }

      this._super();

      this.originalDocumentTitle = '';
      this.titleFlashConversationId = null;
    },

    _getParticipantAddNotificationOptions: function(pushData) {
      return {
        title: pushData.data.name,
        icon: viewHelpers.thumb_for_profile(pushData.data, 'default'),
        summary: t('has joined a conversation #conversation'),
        text: t('{0} has joined a conversation #conversation').format(pushData.data.name)
      };
    },

    _getParticipantLeaveNotificationOptions: function(pushData) {
      return {
        title: pushData.created_by.name,
        icon: viewHelpers.thumb_for_profile(pushData.created_by, 'default'),
        summary: t('has left a conversation #conversation'),
        text: t('{0} has left a conversation #conversation').format(pushData.created_by.name)
      };
    },

    _getMessageNotificationOptions: function(pushData) {
      return {
        title: pushData.created_by.name,
        icon: viewHelpers.thumb_for_profile(pushData.created_by, 'default'),
        summary: '"' + pushData.text + '"',
        text: t('{0} sent you a message #conversations').format(pushData.created_by.name)
      };
    },

    _getLiveStartNotificationOptions: function(pushData) {
      return {
        title: pushData.created_by.name,
        icon: viewHelpers.thumb_for_profile(pushData.created_by, 'default'),
        text: pushData.created_by.name,
        summary: t('is calling you #omega'),
        footerTemplate: jstAudioVideoFooter,
        footerTemplateData: {
          conversationId: pushData.conversation_id,
          liveId: pushData.data.live_id,
          provider: pushData.data.provider
        }
      };
    },

    onPushConversationRead: function(pushData) {
      if (pushData.conversation_id === this.titleFlashConversationId) {
        this.stopDocumentTitleFlashing(pushData.conversation_id);
      }
    },

    onPushConversationEvent: function(pushData) {
      var options;
      var markup;

      var sound = pushData.action === 'live_start' ? this.CALL_SOUND : this.NOTIFICATION_SOUND;

      // ignore your own notifications generated by iOS
      if (pushData.created_by.type === 'user' && pushData.created_by.id === podioConfig.user.user_id) {
        return false;
      }

      if ((this.suppressBubbles || !pushData.settings.popup) && !_.include(this.notSuppressableTypes, pushData.action)) {
        if (pushData.settings.sound) {
          Notifications.playSound(sound);
        }
        return false;
      }

      switch (pushData.action) {
      case 'participant_add':
        options = this._getParticipantAddNotificationOptions(pushData);
        break;
      case 'participant_leave':
        options = this._getParticipantLeaveNotificationOptions(pushData);
        break;
      case 'message':
        options = this._getMessageNotificationOptions(pushData);
        break;
      case 'live_start':
        options = this._getLiveStartNotificationOptions(pushData);
        break;
      }

      // if we have received some unhandled events
      // like live_end
      if (!options) {
        return false;
      }

      _.extend(options, {
        dataId: pushData.conversation_id,
        customClass: pushData.action === 'live_start' ? 'av-notification' : 'conversation-notification'
      });

      var callback = function(open) {
        if (open) {
          podioEvent.trigger(podioEvent.Types.onChatNotificationClicked, pushData.conversation_id);
        }
      };

      markup = this.getTemplate(jstNotification, options);

      Notifications.renderAll(pushData.created_by.name, options.text, markup, callback, viewHelpers.avatar_url_for(pushData.created_by, 'medium'), {
        soundFile: sound,
        sticky: pushData.action === 'live_start'
      }, pushData.settings);
    },

    supressBubbles: function() {
      this.suppressBubbles = true;
    },

    stopSupressingBubbles: function() {
      this.suppressBubbles = false;
    },

    stopDocumentTitleFlashing: function(conversationId) {
      if (this.flashTitleTimer) {
        window.clearInterval(this.flashTitleTimer);
      }

      if (this.originalDocumentTitle) {
        document.title = this.originalDocumentTitle;
      }

      this.titleFlashConversationId = null;
    }

  });

});

